import { Resource, ResourceLanguage } from 'i18next';
import { ExtensionInterface } from 'probonio-shared-ui/registry/extension-definition';

export abstract class TranslationExtensionInterface extends ExtensionInterface {
  /**
   * Base moduleName for the translations.
   * The translation will be available bellow this moduleName.
   *
   * If the moduleName is "example":
   *
   * ```ts
   * const {t} = useTranslation("extensions")
   * return <>{t("example.someTranslation")}</>
   * ```
   */
  abstract moduleName: string;
  abstract get translations(): Resource | ResourceLanguage;
}
